import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "recommended-products" };
const _hoisted_2 = { class: "products-wrapper" };
const _hoisted_3 = { class: "container products" };
const _hoisted_4 = { class: "recommended-products__wrapper" };
const _hoisted_5 = { class: "sidebar-wrapper" };
const _hoisted_6 = { class: "sidebar-sticky-container" };
const _hoisted_7 = { class: "recommended-products__actions" };
const _hoisted_8 = {
    key: 0,
    class: "recommended-products__pdf-error"
};
const _hoisted_9 = { class: "recommended-products__sidebar" };
const _hoisted_10 = { class: "recommended-products__nav" };
const _hoisted_11 = ["disabled", "onClick"];
const _hoisted_12 = { class: "recommended-products__nav-icon" };
const _hoisted_13 = ["src", "alt"];
const _hoisted_14 = { class: "recommended-products__nav-text" };
const _hoisted_15 = ["onClick", "title"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = { class: "main-content-wrapper" };
const _hoisted_19 = { class: "recommended-products__mobile-filter-bar" };
const _hoisted_20 = {
    key: 0,
    class: "recommended-products__filter-badge"
};
const _hoisted_21 = { class: "recommended-products__content" };
const _hoisted_22 = ["id"];
const _hoisted_23 = { class: "recommended-products__section" };
const _hoisted_24 = { class: "recommended-products__section-header" };
const _hoisted_25 = { class: "recommended-products__section-title" };
const _hoisted_26 = { class: "recommended-products__section-title" };
const _hoisted_27 = {
    key: 0,
    class: "recommended-products__details"
};
const _hoisted_28 = { style: { "display": "flex", "flex-direction": "column" } };
const _hoisted_29 = { class: "recommended-products__detail-label recommended-products__detail-label--capitalise" };
const _hoisted_30 = ["innerHTML"];
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = {
    key: 1,
    class: "recommended-products__code-toggle"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = { class: "recommended-products__accordion-icon" };
const _hoisted_36 = {
    key: 0,
    width: "36",
    height: "36",
    viewBox: "0 0 20 20",
    fill: "none"
};
const _hoisted_37 = {
    key: 1,
    width: "36",
    height: "36",
    viewBox: "0 0 20 20",
    fill: "none"
};
const _hoisted_38 = { class: "recommended-products__option-title" };
const _hoisted_39 = { class: "recommended-products__accordion-content" };
const _hoisted_40 = ["onClick", "title"];
const _hoisted_41 = { class: "recommended-products__left-border" };
const _hoisted_42 = {
    key: 0,
    class: "number"
};
const _hoisted_43 = { class: "recommended-products__card-image-container" };
const _hoisted_44 = ["src", "alt"];
const _hoisted_45 = { class: "recommended-products__card-info" };
const _hoisted_46 = { class: "recommended-products__card-name" };
const _hoisted_47 = { key: 0 };
const _hoisted_48 = {
    key: 1,
    class: "recommended-products__card-usage"
};
const _hoisted_49 = ["aria-hidden"];
const _hoisted_50 = {
    key: 0,
    class: "recommended-products__usage-html"
};
const _hoisted_51 = ["innerHTML"];
const _hoisted_52 = {
    key: 0,
    class: "recommended-products__usage-wrapper"
};
const _hoisted_53 = { class: "recommended-products__usage-card--contents" };
const _hoisted_54 = ["innerHTML"];
const _hoisted_55 = { class: "recommended-products__mobile-drawer-content" };
const _hoisted_56 = { class: "recommended-products__mobile-nav" };
const _hoisted_57 = ["disabled", "onClick"];
const _hoisted_58 = { class: "recommended-products__mobile-nav-icon" };
const _hoisted_59 = ["src", "alt"];
const _hoisted_60 = { class: "recommended-products__mobile-nav-text" };
const _hoisted_61 = ["onClick", "title"];
const _hoisted_62 = ["src"];
const _hoisted_63 = ["src"];
const _hoisted_64 = { class: "recommended-products__mobile-drawer-footer" };
import { ref, onMounted, onUnmounted, reactive, computed, watch } from 'vue';
import { useAssets } from '../../composables/useAssets';
import { useProductActions } from '../../composables/useProductActions';
import OutlineButton from '../ui/OutlineButton.vue';
import Toast from '../ui/Toast.vue';
import { useVehicleComponents } from '../../composables/useVehicleComponents';
import ShareRecommendationModal from './ShareRecommendationModal.vue';
import { useShareRecommendation } from '../../composables/useShareRecommendation';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
const VEHICLE_KEY = 'selectedVehicleId';
const LICENCE_PLATE_KEY = 'selectedLicencePlate';
const VISIBLE_COMPONENTS = 'selectedVisibleComponents';
const STICKY_HEADER_OFFSET = 180;
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecommendedVehicleComponents',
    setup(__props) {
        const { assetUrl } = useAssets();
        const { printRecommendationPdf, downloadRecommendationPdf, cleanup } = useProductActions();
        const { licencePlate, vehicleDetails } = useVehicleDetails();
        const { openShareModal } = useShareRecommendation();
        const { vehicleComponents } = useVehicleComponents();
        const activeComponent = ref('');
        // Store refs to section elements for scrolling
        const sectionRefs = ref({});
        const setSectionRef = (id, el) => {
            sectionRefs.value[id] = el;
        };
        const recommendedUsageColumnHtml = (product) => [
            product.recommended_usage_col_1,
            product.recommended_usage_col_2,
            product.recommended_usage_col_3,
        ];
        /**
         * Merge &lt;p&gt;&lt;strong&gt;Label&lt;/strong&gt;&lt;/p&gt;&lt;p&gt;codes…&lt;/p&gt; into one block so the
         * label + specs stay on one row (same idea as RecommendationPdfPresenter::mergeOrphanBoldLabelParagraphsForPdf).
         */
        const mergeOrphanBoldLabelParagraphs = (html) => {
            const trimmed = html.trim();
            if (trimmed === '' || !trimmed.includes('<p')) {
                return trimmed;
            }
            const matches = [...trimmed.matchAll(/<p\b[^>]*>([\s\S]*?)<\/p>/gi)];
            if (matches.length <= 1) {
                return trimmed;
            }
            const unwrapOuterDivLayers = (s) => {
                let t = s.trim();
                for (let d = 0; d < 4; d++) {
                    const m = /^<div\b[^>]*>([\s\S]*)<\/div>$/iu.exec(t);
                    if (!m) {
                        break;
                    }
                    const inner = m[1].trim();
                    if (inner === '' || /<div\b/iu.test(inner)) {
                        break;
                    }
                    t = inner;
                }
                return t;
            };
            const unwrapOuterSpanLayers = (s) => {
                let t = s.trim();
                for (let d = 0; d < 8; d++) {
                    const m = /^<span\b[^>]*>([\s\S]*)<\/span>$/iu.exec(t);
                    if (!m) {
                        break;
                    }
                    const inner = m[1].trim();
                    if (inner === '') {
                        break;
                    }
                    t = inner;
                }
                return t;
            };
            const isBoldLabelOnlyFragment = (fragment) => {
                let t = unwrapOuterDivLayers(fragment);
                t = unwrapOuterSpanLayers(t);
                return /^\s*<(strong|b)\b[^>]*>[\s\S]*?<\/\1>\s*$/iu.test(t);
            };
            const nextStartsWithBold = (s) => /^\s*(?:<span\b[^>]*>\s*)?<(strong|b)\b/iu.test(s.trim());
            const mergedInners = [];
            let i = 0;
            const n = matches.length;
            while (i < n) {
                const inner = (matches[i][1] ?? '').trim();
                const nextInner = i + 1 < n ? (matches[i + 1][1] ?? '').trim() : '';
                const isLabelOnly = inner !== '' && isBoldLabelOnlyFragment(inner);
                if (isLabelOnly && nextInner !== '' && !nextStartsWithBold(nextInner)) {
                    mergedInners.push(`${inner} ${nextInner}`);
                    i += 2;
                }
                else {
                    mergedInners.push(inner);
                    i += 1;
                }
            }
            if (mergedInners.length === matches.length) {
                return trimmed;
            }
            return `<p>${mergedInners.join('</p><p>')}</p>`;
        };
        /**
         * One visual row per segment: <br>, literal newlines, or separate <p>...</p> blocks.
         * Multiple paragraphs were previously merged because we only split on <br> and forced p { display: inline }.
         */
        const splitRecommendedUsageHtmlByLineBreaks = (html) => {
            if (html == null || String(html).trim() === '') {
                return [];
            }
            let raw = String(html).trim();
            raw = mergeOrphanBoldLabelParagraphs(raw);
            const pBlocks = [...raw.matchAll(/<p\b[^>]*>[\s\S]*?<\/p>/gi)].map((m) => m[0].trim()).filter((b) => b !== '');
            if (pBlocks.length > 1) {
                return pBlocks;
            }
            let s = raw;
            const pWrapped = /^<p\b[^>]*>([\s\S]*)<\/p>$/i.exec(s);
            if (pWrapped) {
                s = pWrapped[1].trim();
            }
            const parts = s
                .split(/<br\s*\/?>|\r\n|\n|\r/gi)
                .map((part) => part.trim())
                .filter((part) => part !== '');
            if (parts.length === 0 && s !== '') {
                return [s];
            }
            return parts;
        };
        const productHasRecommendedUsage = (product) => recommendedUsageColumnHtml(product).some((html) => html != null && String(html).trim() !== '');
        // Track visibility state for each component
        const visibleComponents = ref({});
        // Mobile filter state
        const showMobileFilters = ref(false);
        // Computed properties for mobile filter badge
        const visibleComponentsCount = computed(() => {
            return Object.values(visibleComponents.value).filter(v => v).length;
        });
        const hiddenComponentsCount = computed(() => {
            return Object.values(visibleComponents.value).filter(v => !v).length;
        });
        // Initialize all components as visible
        const activeCodeID = reactive({});
        const observer = ref(null);
        // Function to initialize component state
        const initializeComponentState = () => {
            // Clear existing state
            Object.keys(visibleComponents.value).forEach(key => {
                delete visibleComponents.value[key];
            });
            Object.keys(activeCodeID).forEach(key => {
                delete activeCodeID[key];
            });
            // Initialize new state
            vehicleComponents.value.forEach(component => {
                visibleComponents.value[component.id] = true;
                if (component.codes && component.codes.length > 0) {
                    activeCodeID[component.id] = component.codes[0].code;
                }
            });
            // Set initial active component
            if (vehicleComponents.value.length > 0) {
                activeComponent.value = vehicleComponents.value[0].id;
            }
            // Check localStorage for visibility preferences
            if (localStorage.getItem(VISIBLE_COMPONENTS)) {
                const savedVisibility = JSON.parse(localStorage.getItem(VISIBLE_COMPONENTS) || '{}');
                // Only apply saved visibility if the component IDs match
                Object.keys(savedVisibility).forEach(key => {
                    if (visibleComponents.value.hasOwnProperty(key)) {
                        visibleComponents.value[key] = savedVisibility[key];
                    }
                });
            }
        };
        // Watch for changes in vehicleComponents and reinitialize
        watch(vehicleComponents, (newComponents) => {
            if (newComponents && newComponents.length > 0) {
                // Clear existing activeCodeID entries
                Object.keys(activeCodeID).forEach(key => {
                    delete activeCodeID[key];
                });
                // Reset active code IDs for each component
                newComponents.forEach((component) => {
                    if (component.codes && component.codes.length > 0) {
                        activeCodeID[component.id] = component.codes[0].code;
                    }
                });
                // Reset visible components
                visibleComponents.value = {};
                newComponents.forEach((component) => {
                    visibleComponents.value[component.id] = true;
                });
                // Reset active component to first one
                activeComponent.value = newComponents[0]?.id || '';
                // Clear section refs
                sectionRefs.value = {};
            }
        }, { deep: true });
        // Toggle visibility (show/hide) for filtering
        const toggleComponentVisibility = (componentId) => {
            visibleComponents.value[componentId] = !visibleComponents.value[componentId];
            localStorage.setItem(VISIBLE_COMPONENTS, JSON.stringify(visibleComponents.value));
        };
        // ... rest of your existing functions (scrollToSection, etc.) ...
        const scrollToSection = (componentId) => {
            if (!visibleComponents.value[componentId])
                return;
            const section = document.getElementById(componentId);
            if (section) {
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                const offset = window.innerWidth >= 1024 ? STICKY_HEADER_OFFSET : 20;
                window.scrollTo({
                    top: sectionTop - offset,
                    behavior: 'smooth'
                });
                activeComponent.value = componentId;
            }
        };
        const scrollToSectionMobile = (componentId) => {
            if (!visibleComponents.value[componentId])
                return;
            toggleMobileFilters();
            setTimeout(() => {
                scrollToSection(componentId);
            }, 100);
        };
        const toggleMobileFilters = () => {
            showMobileFilters.value = !showMobileFilters.value;
            if (showMobileFilters.value) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = '';
            }
        };
        const observeSections = () => {
            const sections = document.querySelectorAll('.recommended-products__section--wrapper');
            const options = {
                root: null,
                rootMargin: '-250px 0px -30% 0px', // Ignore top 200px due to sticky header
                threshold: 0.25
            };
            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        activeComponent.value = entry.target.id;
                    }
                });
            }, options);
            sections.forEach((section) => {
                intersectionObserver.observe(section);
            });
            return intersectionObserver;
        };
        const setActiveCode = (componentId, codeId) => {
            activeCodeID[componentId] = codeId;
        };
        const boldNumbers = (text) => {
            return text.replace(/(\d+\.?\d*)/g, '<strong>$1</strong>');
        };
        const formatCapacityValue = (value, unit) => {
            const normalizedValue = (value || '').replace(/,/g, '.');
            return `${normalizedValue} ${unit || ''}`.trim();
        };
        const getActiveCodeProducts = (component) => {
            const activeCode = String(activeCodeID[component.id] ?? component.codes[0]?.code);
            const codeData = component.codes.find(c => String(c.code) === activeCode);
            if (!codeData?.productGroups) {
                return [];
            }
            // Flatten all products from all groups
            return codeData.productGroups.flatMap(group => group.products);
        };
        const getActiveCodeProductGroups = (component) => {
            const activeCode = String(activeCodeID[component.id] ?? component.codes[0]?.code);
            const codeData = component.codes.find(c => String(c.code) === activeCode);
            const groups = codeData?.productGroups || [];
            // Initialize accordion state if not already initialized
            if (groups.length > 0) {
                initializeAccordionState(component.id, groups);
            }
            return groups;
        };
        const getActiveCodeUsage = (component) => {
            const activeCode = String(activeCodeID[component.id] ?? component.codes[0]?.code);
            const codeData = component.codes.find(c => String(c.code) === activeCode);
            return codeData?.usage || [];
        };
        const getActiveCodeCapacities = (component) => {
            const activeCode = String(activeCodeID[component.id] ?? component.codes[0]?.code);
            const codeData = component.codes.find(c => String(c.code) === activeCode);
            return codeData?.capacities || component.capacities || [];
        };
        const formatUsageIntervalName = (intervalName) => {
            return intervalName.replace(/\d+/g, (match) => {
                const number = parseInt(match, 10);
                return number >= 1000
                    ? number.toLocaleString('en-GB')
                    : match;
            });
        };
        const formatUsageIntervalOutput = (intervalType, intervalName) => {
            const formattedName = formatUsageIntervalName(intervalName);
            const withWrappedLabels = formattedName.replace(/(\|\s*)([A-Za-z ]+):/g, (_match, prefix, label) => {
                return `${prefix}<span>${label}:</span>`;
            });
            return `<span>${intervalType}:</span> ${withWrappedLabels}`;
        };
        // Get usages for a specific product group
        const getGroupUsages = (group) => {
            if (group.usage && group.usage.length > 0) {
                return group.usage.map(usage => ({
                    title: usage.title,
                    intervalName: formatUsageIntervalName(usage.intervalName),
                    intervalType: usage.intervalType
                }));
            }
            const usageMap = new Map();
            group.products.forEach(product => {
                const useName = product.use_name || '';
                const useAppOrder = product.use_app_order || 999;
                if (product.intervals && product.intervals.length > 0) {
                    product.intervals.forEach(interval => {
                        // Create a unique key combining useName and interval details
                        const key = `${useName}_${interval.intervalName}_${interval.intervalType}`;
                        if (!usageMap.has(key)) {
                            usageMap.set(key, {
                                title: useName,
                                intervalName: interval.intervalName,
                                intervalType: interval.intervalType,
                                useAppOrder: useAppOrder,
                                intervalAppOrder: interval.appOrder || 999
                            });
                        }
                    });
                }
                else if (useName) {
                    // Fallback if no intervals but has use_name
                    const key = `${useName}_${product.id}`;
                    if (!usageMap.has(key)) {
                        usageMap.set(key, {
                            title: useName,
                            intervalName: '',
                            intervalType: 'Change',
                            useAppOrder: useAppOrder,
                            intervalAppOrder: 999
                        });
                    }
                }
            });
            // Sort by useAppOrder (ascending), then by intervalAppOrder (ascending)
            const sortedUsages = Array.from(usageMap.values()).sort((a, b) => {
                if (a.useAppOrder === b.useAppOrder) {
                    return a.intervalAppOrder - b.intervalAppOrder;
                }
                return a.useAppOrder - b.useAppOrder;
            });
            // Return only the fields needed for display, filtering out incomplete entries
            return sortedUsages
                .filter(usage => usage.title && usage.intervalType && usage.intervalName)
                .map(usage => ({
                title: usage.title,
                intervalName: formatUsageIntervalName(usage.intervalName),
                intervalType: usage.intervalType
            }));
        };
        // Track accordion state: componentId -> group number -> isOpen
        const accordionState = reactive({});
        // Initialize accordion state - first option open by default
        const initializeAccordionState = (componentId, groups) => {
            if (!accordionState[componentId]) {
                accordionState[componentId] = {};
            }
            groups.forEach((group, index) => {
                if (accordionState[componentId][group.group] === undefined) {
                    // First group (index 0) is open by default
                    accordionState[componentId][group.group] = index === 0;
                }
            });
        };
        // Toggle accordion state
        const toggleAccordion = (componentId, groupNumber) => {
            if (!accordionState[componentId]) {
                accordionState[componentId] = {};
            }
            accordionState[componentId][groupNumber] = !accordionState[componentId][groupNumber];
        };
        // Check if accordion is open
        const isAccordionOpen = (componentId, groupNumber) => {
            return accordionState[componentId]?.[groupNumber] ?? false;
        };
        const pdfDownloadError = ref('');
        const pdfActionPending = ref(null);
        const pdfToastMessage = computed(() => {
            if (pdfActionPending.value === 'print') {
                return 'Preparing print…';
            }
            if (pdfActionPending.value === 'download') {
                return 'Preparing download…';
            }
            return '';
        });
        const buildRecommendationPdfPayload = (opts) => {
            const typeId = vehicleDetails.value?.type_id;
            if (typeId === undefined || typeId === null || String(typeId).trim() === '') {
                return null;
            }
            return {
                type_id: Number(typeId),
                licence_plate: licencePlate.value || null,
                vehicle: JSON.parse(JSON.stringify(vehicleDetails.value ?? {})),
                components: JSON.parse(JSON.stringify(vehicleComponents.value)),
                visible_components: JSON.parse(JSON.stringify(visibleComponents.value)),
                active_code_id: JSON.parse(JSON.stringify(activeCodeID)),
                accordion_state: JSON.parse(JSON.stringify(accordionState)),
                for_print: opts?.forPrint === true,
            };
        };
        const handlePdf = () => {
            void (async () => {
                pdfDownloadError.value = '';
                try {
                    const payload = buildRecommendationPdfPayload({ forPrint: false });
                    if (!payload) {
                        pdfDownloadError.value = 'Vehicle data is not ready.';
                        return;
                    }
                    pdfActionPending.value = 'download';
                    await downloadRecommendationPdf(payload);
                }
                catch (err) {
                    pdfDownloadError.value = err instanceof Error ? err.message : 'Could not generate the PDF.';
                }
                finally {
                    pdfActionPending.value = null;
                }
            })();
        };
        const handlePrintPdf = () => {
            void (async () => {
                pdfDownloadError.value = '';
                try {
                    const payload = buildRecommendationPdfPayload({ forPrint: true });
                    if (!payload) {
                        pdfDownloadError.value = 'Vehicle data is not ready.';
                        return;
                    }
                    pdfActionPending.value = 'print';
                    await printRecommendationPdf(payload);
                }
                catch (err) {
                    pdfDownloadError.value = err instanceof Error ? err.message : 'Could not generate the PDF.';
                }
                finally {
                    pdfActionPending.value = null;
                }
            })();
        };
        const selectProduct = (product) => {
            if (licencePlate.value) {
                localStorage.setItem(LICENCE_PLATE_KEY, licencePlate.value.toString());
            }
            if (vehicleDetails.value && vehicleDetails.value.type_id) {
                localStorage.setItem(VEHICLE_KEY, vehicleDetails.value.type_id.toString());
            }
            window.location.href = product.url;
        };
        onMounted(() => {
            // Initialize component state on mount
            initializeComponentState();
            observer.value = observeSections();
        });
        onUnmounted(() => {
            if (observer.value) {
                observer.value.disconnect();
            }
            cleanup();
            document.body.style.overflow = '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Toast, {
                    show: !!pdfActionPending.value,
                    message: pdfToastMessage.value
                }, null, 8, ["show", "message"]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "header-wrapper" }, [
                    _createElementVNode("div", { class: "container" }, [
                        _createElementVNode("h1", { class: "recommended-products__header" }, "Recommended products")
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        (pdfDownloadError.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(pdfDownloadError.value), 1))
                                            : _createCommentVNode("", true),
                                        _createVNode(OutlineButton, {
                                            label: "Download",
                                            icon: _unref(assetUrl)('/images/trade-site/download.svg'),
                                            action: handlePdf,
                                            disabled: !!pdfActionPending.value
                                        }, null, 8, ["icon", "disabled"]),
                                        _createVNode(OutlineButton, {
                                            label: "Print",
                                            icon: _unref(assetUrl)('/images/trade-site/printer.svg'),
                                            action: handlePrintPdf,
                                            disabled: !!pdfActionPending.value
                                        }, null, 8, ["icon", "disabled"]),
                                        _createVNode(OutlineButton, {
                                            label: "Share",
                                            icon: _unref(assetUrl)('/images/trade-site/share.svg'),
                                            action: _unref(openShareModal)
                                        }, null, 8, ["icon", "action"]),
                                        _createVNode(ShareRecommendationModal)
                                    ]),
                                    _createElementVNode("aside", _hoisted_9, [
                                        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "recommended-products__sidebar-title" }, "Component", -1)),
                                        _createElementVNode("nav", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehicleComponents), (category, categoryIndex) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: categoryIndex,
                                                    class: _normalizeClass(["recommended-products__nav-item", {
                                                            'recommended-products__nav-item--active': activeComponent.value === category.id,
                                                            'recommended-products__nav-item--hidden': !visibleComponents.value[category.id]
                                                        }])
                                                }, [
                                                    _createElementVNode("button", {
                                                        class: "recommended-products__nav-main",
                                                        disabled: !visibleComponents.value[category.id],
                                                        onClick: ($event) => (scrollToSection(category.id))
                                                    }, [
                                                        _createElementVNode("span", _hoisted_12, [
                                                            _createElementVNode("img", {
                                                                src: _unref(assetUrl)(category.title.toLowerCase() === 'engine' ? '/images/trade-site/tab-engine.svg' : '/images/trade-site/tab-transmission.svg'),
                                                                alt: `${category.title} icon`
                                                            }, null, 8, _hoisted_13)
                                                        ]),
                                                        _createElementVNode("span", _hoisted_14, _toDisplayString(category.title), 1)
                                                    ], 8, _hoisted_11),
                                                    _createElementVNode("button", {
                                                        class: "recommended-products__nav-visibility",
                                                        onClick: ($event) => (toggleComponentVisibility(category.id)),
                                                        title: visibleComponents.value[category.id] ? 'Hide section' : 'Show section'
                                                    }, [
                                                        (visibleComponents.value[category.id])
                                                            ? (_openBlock(), _createElementBlock("img", {
                                                                key: 0,
                                                                src: _unref(assetUrl)('/images/trade-site/eye-open.svg'),
                                                                alt: "Visible"
                                                            }, null, 8, _hoisted_16))
                                                            : (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: _unref(assetUrl)('/images/trade-site/eye-closed.svg'),
                                                                alt: "Hidden"
                                                            }, null, 8, _hoisted_17))
                                                    ], 8, _hoisted_15)
                                                ], 2));
                                            }), 128))
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                        class: "recommended-products__mobile-filter-btn",
                                        onClick: toggleMobileFilters
                                    }, [
                                        _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                            class: "recommended-products__filter-icon",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 20 20",
                                            fill: "none"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M2 4h16M4 10h12M7 16h6",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round"
                                            })
                                        ], -1)),
                                        _cache[3] || (_cache[3] = _createTextVNode(" Components ", -1)),
                                        (hiddenComponentsCount.value > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(visibleComponentsCount.value), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("main", _hoisted_21, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehicleComponents), (component, componentListIndex) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("section", {
                                            key: componentListIndex,
                                            id: component.id,
                                            ref_for: true,
                                            ref: el => setSectionRef(component.id, el),
                                            class: "recommended-products__section--wrapper"
                                        }, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("h2", _hoisted_25, _toDisplayString(component.title), 1),
                                                    _createElementVNode("h2", _hoisted_26, _toDisplayString(activeCodeID[component.id]), 1)
                                                ]),
                                                (getActiveCodeCapacities(component).length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                        _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Capacities", -1)),
                                                        _createElementVNode("div", _hoisted_28, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getActiveCodeCapacities(component), (capacity, capacityIndex) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: capacityIndex,
                                                                    class: "recommended-products__detail"
                                                                }, [
                                                                    _createElementVNode("span", _hoisted_29, _toDisplayString(capacity.title), 1),
                                                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "recommended-products__detail--dots" }, null, -1)),
                                                                    _createElementVNode("span", {
                                                                        class: "recommended-products__detail-label recommended-products__detail-label--desktop-value",
                                                                        innerHTML: boldNumbers(formatCapacityValue(capacity.value, capacity.unit))
                                                                    }, null, 8, _hoisted_30),
                                                                    _createElementVNode("span", {
                                                                        class: "recommended-products__detail-label recommended-products__detail-label--mobile-value",
                                                                        innerHTML: boldNumbers(formatCapacityValue(capacity.mobileValue || capacity.value, capacity.unit))
                                                                    }, null, 8, _hoisted_31)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (component.codes.length > 1)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.codes, (codeItem, codeIndex) => {
                                                            return (_openBlock(), _createElementBlock("button", {
                                                                key: codeIndex,
                                                                class: _normalizeClass([
                                                                    'recommended-products__code-button',
                                                                    { 'recommended-products__code-button--active': activeCodeID[component.id] === codeItem.code }
                                                                ]),
                                                                onClick: ($event) => (setActiveCode(component.id, codeItem.code))
                                                            }, _toDisplayString(codeItem.code), 11, _hoisted_33));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getActiveCodeProductGroups(component), (group, groupIndex) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
                                                        (getActiveCodeProductGroups(component).length > 1)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: _normalizeClass(["recommended-products__accordion-header", {
                                                                        'recommended-products__accordion-header--open': isAccordionOpen(component.id, group.group),
                                                                        'recommended-products__accordion-header--closed': !isAccordionOpen(component.id, group.group)
                                                                    }]),
                                                                onClick: ($event) => (toggleAccordion(component.id, group.group))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_35, [
                                                                    (isAccordionOpen(component.id, group.group))
                                                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_36, [...(_cache[6] || (_cache[6] = [
                                                                                _createElementVNode("circle", {
                                                                                    cx: "10",
                                                                                    cy: "10",
                                                                                    r: "9",
                                                                                    fill: "#fff",
                                                                                    "stroke-width": "2"
                                                                                }, null, -1),
                                                                                _createElementVNode("path", {
                                                                                    d: "M6 10H14",
                                                                                    stroke: "#002649",
                                                                                    "stroke-width": "2",
                                                                                    "stroke-linecap": "round"
                                                                                }, null, -1)
                                                                            ]))]))
                                                                        : (_openBlock(), _createElementBlock("svg", _hoisted_37, [...(_cache[7] || (_cache[7] = [
                                                                                _createElementVNode("circle", {
                                                                                    cx: "10",
                                                                                    cy: "10",
                                                                                    r: "9",
                                                                                    fill: "#fff",
                                                                                    "stroke-width": "2"
                                                                                }, null, -1),
                                                                                _createElementVNode("path", {
                                                                                    d: "M6 10H14M10 6V14",
                                                                                    stroke: "#00264C",
                                                                                    "stroke-width": "2",
                                                                                    "stroke-linecap": "round"
                                                                                }, null, -1)
                                                                            ]))]))
                                                                ]),
                                                                _createElementVNode("h2", _hoisted_38, "Option " + _toDisplayString(group.group), 1)
                                                            ], 10, _hoisted_34))
                                                            : _createCommentVNode("", true),
                                                        _withDirectives(_createElementVNode("div", _hoisted_39, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.products, (product, productIndex) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: product.id,
                                                                    class: "recommended-products__card",
                                                                    onClick: ($event) => (selectProduct(product)),
                                                                    title: `View ${product.title}`
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_41, [
                                                                        (group.products.length > 1)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                                _cache[8] || (_cache[8] = _createElementVNode("svg", {
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    width: "33",
                                                                                    height: "33",
                                                                                    viewBox: "0 0 33 33",
                                                                                    fill: "none"
                                                                                }, [
                                                                                    _createElementVNode("path", {
                                                                                        d: "M16.1667 30.3333C23.9907 30.3333 30.3333 23.9907 30.3333 16.1667C30.3333 8.34263 23.9907 2 16.1667 2C8.34263 2 2 8.34263 2 16.1667C2 23.9907 8.34263 30.3333 16.1667 30.3333Z",
                                                                                        fill: "#00264C",
                                                                                        stroke: "#1E1E1E",
                                                                                        "stroke-width": "4",
                                                                                        "stroke-linecap": "round",
                                                                                        "stroke-linejoin": "round"
                                                                                    })
                                                                                ], -1)),
                                                                                _createElementVNode("span", null, _toDisplayString(group.products.length > 1 ? productIndex + 1 : ' '), 1)
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_43, [
                                                                        _createElementVNode("img", {
                                                                            src: product.image,
                                                                            alt: product.title,
                                                                            class: "recommended-products__card-image"
                                                                        }, null, 8, _hoisted_44)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_45, [
                                                                        _createElementVNode("h3", _hoisted_46, [
                                                                            _createTextVNode(_toDisplayString(product.id) + " ", 1),
                                                                            _createElementVNode("span", {
                                                                                class: "recommended-products__card--badge",
                                                                                style: _normalizeStyle(`background: ${product.hexcode}`)
                                                                            }, _toDisplayString(product.title), 5)
                                                                        ]),
                                                                        (productHasRecommendedUsage(product))
                                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_47, "Recommended for use in vehicles requiring:"))
                                                                            : _createCommentVNode("", true),
                                                                        (productHasRecommendedUsage(product))
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedUsageColumnHtml(product), (colHtml, colIdx) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: colIdx,
                                                                                        class: _normalizeClass(["recommended-products__usage-col", { 'recommended-products__usage-col--empty': colHtml == null || String(colHtml).trim() === '' }]),
                                                                                        "aria-hidden": colHtml == null || String(colHtml).trim() === '' ? true : undefined
                                                                                    }, [
                                                                                        (colHtml != null && String(colHtml).trim() !== '')
                                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitRecommendedUsageHtmlByLineBreaks(colHtml), (lineHtml, lineIdx) => {
                                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                                        key: lineIdx,
                                                                                                        class: "recommended-products__usage-html-line",
                                                                                                        innerHTML: lineHtml
                                                                                                    }, null, 8, _hoisted_51));
                                                                                                }), 128))
                                                                                            ]))
                                                                                            : _createCommentVNode("", true)
                                                                                    ], 10, _hoisted_49));
                                                                                }), 128))
                                                                            ]))
                                                                            : _createCommentVNode("", true)
                                                                    ])
                                                                ], 8, _hoisted_40));
                                                            }), 128)),
                                                            (getGroupUsages(group).length > 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGroupUsages(group), (usage, usageIndex) => {
                                                                        return (_openBlock(), _createElementBlock("div", {
                                                                            key: usageIndex,
                                                                            class: "recommended-products__usage-card"
                                                                        }, [
                                                                            _cache[10] || (_cache[10] = _createElementVNode("img", {
                                                                                src: "/images/trade-site/info-icon.svg",
                                                                                alt: "Info Icon"
                                                                            }, null, -1)),
                                                                            _createElementVNode("div", _hoisted_53, [
                                                                                _createElementVNode("div", null, [
                                                                                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Usage:", -1)),
                                                                                    _createTextVNode(" " + _toDisplayString(usage.title), 1)
                                                                                ]),
                                                                                (usage.intervalName)
                                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                                        key: 0,
                                                                                        innerHTML: formatUsageIntervalOutput(usage.intervalType, usage.intervalName)
                                                                                    }, null, 8, _hoisted_54))
                                                                                    : _createCommentVNode("", true)
                                                                            ])
                                                                        ]));
                                                                    }), 128))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 512), [
                                                            [_vShow, getActiveCodeProductGroups(component).length === 1 || isAccordionOpen(component.id, group.group)]
                                                        ])
                                                    ], 64));
                                                }), 128))
                                            ])
                                        ], 8, _hoisted_22)), [
                                            [_vShow, visibleComponents.value[component.id]]
                                        ]);
                                    }), 128))
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "recommended-products__tcs" }, [
                                    _createElementVNode("span", { class: "text" }, [
                                        _createTextVNode("Our "),
                                        _createElementVNode("a", { href: "/terms-and-conditions" }, "terms and conditions"),
                                        _createTextVNode(" apply on this recommendation.")
                                    ]),
                                    _createElementVNode("span", { class: "print-text" }, "Please check our terms and conditions that apply on this recommendation at https://pro.duckhams.com/terms-and-conditions")
                                ], -1))
                            ])
                        ])
                    ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, { name: "mobile-filter" }, {
                        default: _withCtx(() => [
                            (showMobileFilters.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "recommended-products__mobile-overlay",
                                    onClick: toggleMobileFilters
                                }, [
                                    _createElementVNode("div", {
                                        class: "recommended-products__mobile-drawer",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                                    }, [
                                        _createElementVNode("div", { class: "recommended-products__mobile-drawer-header" }, [
                                            _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "recommended-products__mobile-drawer-title" }, "Components", -1)),
                                            _createElementVNode("button", {
                                                class: "recommended-products__mobile-drawer-close",
                                                onClick: toggleMobileFilters
                                            }, [...(_cache[12] || (_cache[12] = [
                                                    _createElementVNode("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            d: "M18 6L6 18M6 6l12 12",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            "stroke-linecap": "round"
                                                        })
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("nav", _hoisted_56, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehicleComponents), (category, categoryIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: categoryIndex,
                                                        class: _normalizeClass(["recommended-products__mobile-nav-item", {
                                                                'recommended-products__mobile-nav-item--active': activeComponent.value === category.id,
                                                                'recommended-products__mobile-nav-item--hidden': !visibleComponents.value[category.id]
                                                            }])
                                                    }, [
                                                        _createElementVNode("button", {
                                                            class: "recommended-products__mobile-nav-main",
                                                            disabled: !visibleComponents.value[category.id],
                                                            onClick: ($event) => (scrollToSectionMobile(category.id))
                                                        }, [
                                                            _createElementVNode("span", _hoisted_58, [
                                                                _createElementVNode("img", {
                                                                    src: _unref(assetUrl)(category.title.toLowerCase() === 'engine' ? '/images/trade-site/tab-engine.svg' : '/images/trade-site/tab-transmission.svg'),
                                                                    alt: `${category.title} icon`
                                                                }, null, 8, _hoisted_59)
                                                            ]),
                                                            _createElementVNode("span", _hoisted_60, _toDisplayString(category.title), 1)
                                                        ], 8, _hoisted_57),
                                                        _createElementVNode("button", {
                                                            class: "recommended-products__mobile-nav-visibility",
                                                            onClick: ($event) => (toggleComponentVisibility(category.id)),
                                                            title: visibleComponents.value[category.id] ? 'Hide section' : 'Show section'
                                                        }, [
                                                            (visibleComponents.value[category.id])
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: _unref(assetUrl)('/images/trade-site/eye-open.svg'),
                                                                    alt: "Visible"
                                                                }, null, 8, _hoisted_62))
                                                                : (_openBlock(), _createElementBlock("img", {
                                                                    key: 1,
                                                                    src: _unref(assetUrl)('/images/trade-site/eye-closed.svg'),
                                                                    alt: "Hidden"
                                                                }, null, 8, _hoisted_63))
                                                        ], 8, _hoisted_61)
                                                    ], 2));
                                                }), 128))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("button", {
                                                class: "recommended-products__mobile-drawer-apply",
                                                onClick: toggleMobileFilters
                                            }, " Show " + _toDisplayString(visibleComponentsCount.value) + " component" + _toDisplayString(visibleComponentsCount.value !== 1 ? 's' : ''), 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
            ]));
        };
    }
});
